import React, { FunctionComponent, useContext, useEffect } from "react";
import { sendLogoutRequest } from "../../api";
import { AppContext } from "../../app/store";
import { logError } from "../../helpers";
import { useHistory, useLocation } from "react-router";
import { ActionType, MctToastType } from "../../@types";
import { getSlsxSignoutUrl } from "../../helpers/loginHelpers";
import { LoadingMask } from "../../components";
import { getLanguageFromLocationOrState } from "../../helpers/languageHelpers";
import { ApiResponseError } from "../../helpers/errors";

export const LogoutPage: FunctionComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const { state, dispatch } = useContext(AppContext);
  const lang = getLanguageFromLocationOrState({
    stateLang: state.language,
    location,
  });

  const logout = async () => {
    const queriesToAppend = {
      mctt: MctToastType.LOGGED_OUT,
      lang,
    };
    try {
      await sendLogoutRequest();
    } catch (e) {
      logError(
        "Could not log out user (MaxGlobalHeader)",
        e as ApiResponseError
      );
    }

    dispatch({ type: ActionType.RESET_STATE });

    if (!state.csr) {
      const signoutUrl = getSlsxSignoutUrl({ queriesToAppend });
      window.location.assign(signoutUrl);
    } else {
      history.push(`/?mctt=${MctToastType.LOGGED_OUT}&lang=${lang}`);
    }
  };

  useEffect(() => {
    logout();
  }, []);

  return <LoadingMask loading={true} />;
};
